import React from 'react'
import { css } from '@linaria/core'
import { colors, useTheme } from '@fs/zion-ui'
import { TextButton } from '@fs/zion-ui/quarks-authorized-use-only'

const headerNavButtonCss = css`
  padding: 11px 8px;
  font-size: 14px;
  height: 36px;
  border: 1px solid transparent;
  border-radius: 4px;
  text-transform: none !important;
  margin-right: 4px;

  background: transparent;
  color: ${colors.gray100};

  &:hover,
  &:focus {
    background: #e1ebc5;
  }

  &[data-theme='night'] {
    &:hover,
    &:focus {
      color: ${colors.gray00};
    }
  }

  &:active {
    background: #e1ebc5;
  }

  transition:
    background-color 0.3s,
    color 0.3s;

  [lang|='zh'] &,
  [lang|='zh-hans'] &,
  [lang|='ja'] &,
  [lang|='ko'] & {
    font-size: 16px;
  }
`

export default function HeaderNavButton({ children, ...props }) {
  const theme = useTheme()
  return (
    <TextButton data-theme={theme} {...props} text={children} className={headerNavButtonCss}>
      {children}
    </TextButton>
  )
}
